import { render } from "./Message.vue?vue&type=template&id=6ea7cfe3&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=6ea7cfe3&lang=sass&scoped=true"
import "./Message.vue?vue&type=style&index=1&id=6ea7cfe3&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea7cfe3"]])

export default __exports__